/* eslint-disable max-len */
import * as React from 'react';
import styled from 'styled-components';
import BackgroundImage from '../../assets/bg_watch.png';
import BackgroundCloud from '../../assets/bg_clouds.png';
import DevicesImage from '../../assets/devices.png';
import FooterHillsImage from '../../assets/bg_footer_hills.png';
import WatchButton from './WatchButton';
import {useTranslation} from 'react-i18next';
import WedgeImage from '../../assets/bg_wedge.png';
import {useIsMobile} from '../../styles';

const CartoonitoParentalWatch = props => {
    let {t} = useTranslation();
    const isMobile = useIsMobile();

    return (
        <Container>
            <Anchor id="waystowatch" />
            <Devices src={DevicesImage} />

            <TitleText>{t('parentalPage.waysToWatch.title')}</TitleText>
            <WatchButton
                image={require('../../assets/logo_hbo_white.png')}
                subtitle={
                    !isMobile && t('parentalPage.waysToWatch.hboSubtitle')
                }
                backgroundColor="#7520CC"
                subtitleColor="white"
                rightImages={[require('../../assets/ic_chevron_white.png')]}
                to={[
                    'https://play.hbomax.com/page/urn:hbo:page:spotlight-cartoonito',
                ]}
            />
            <WatchButton
                title={t('parentalPage.waysToWatch.watchOnTV')}
                subtitle={!isMobile && t('parentalPage.waysToWatch.tvSubtitle')}
                backgroundColor="#F6D703"
                subtitleColor="black"
                rightImages={[require('../../assets/ic_chevron_black.png')]}
                to={[programmingLink()]}
            />
            <WatchButton
                image={require('../../assets/logo_cnito_watch.png')}
                subtitle={
                    !isMobile && t('parentalPage.waysToWatch.cnitoSubtitle')
                }
                backgroundColor="black"
                subtitleColor="white"
                rightImages={[
                    require('../../assets/ic_google_play_small.png'),
                    require('../../assets/ic_app_store_small.png'),
                ]}
                to={[
                    'https://play.google.com/store/apps/details?id=com.turner.cnja.br',
                    'https://apps.apple.com/br/app/cartoon-network/id1290928633',
                ]}
            />
            <Decorator src={WedgeImage} />
            <Disclaimer>{t('parentalPage.waysToWatch.disclaimer')}</Disclaimer>
            <Hills src={FooterHillsImage} alt="footer" />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    background-image: url(${BackgroundCloud}), url(${BackgroundImage});
    background-repeat: no-repeat, repeat-x;
    background-size: contain, auto;
    margin-top: -10px;
    align-items: center;
    position: relative;
`;

const Devices = styled.img`
    margin: 105px auto 32px auto;
    align-self: center;
`;

const TitleText = styled.div`
    font-family: 'Rodger';
    font-style: normal;
    font-weight: 900;
    font-size: 36px;
    line-height: 43px;
    text-align: center;
    letter-spacing: 2.5px;
    text-transform: uppercase;
    margin-bottom: 54px;
`;

const Disclaimer = styled.div`
    font-family: Oduda;
    font-size: 14px;
    font-weight: 400;
    font-size: 14px;
    color: white;
    opacity: 0.85;
    max-width: 505px;
    text-align: center;
    margin: 20px 16px 100px 16px;
`;

const Anchor = styled.a`
    display: block;
    position: relative;
    top: -120px;
    visibility: hidden;
`;

const Decorator = styled.img`
    align-self: center;
    position: absolute;
    bottom: 127px;
    right: calc(50% - 623px);
`;

const Hills = styled.img`
    background-repeat: repeat;
    width: 100%;
`;

export const programmingLink = () => {
    let host = window.location.hostname.split('.');
    let cc = host[host.length - 1];

    switch (cc) {
        case 'br':
            return 'https://www.cartoonito.com.br/programacao';
        case 'mx':
            return 'https://www.cartoonito.com.ar/programacion';
        case 'cl':
            return 'https://www.cartoonito.cl/programacion';
        case 'co':
            return 'https://www.cartoonito.com.co/programacion';
        case 'ec':
            return 'https://www.cartoonito.com.ec/programacion';
        case 'pe':
            return 'https://www.cartoonito.com.pe/programacion';
        case 'uy':
            return 'https://www.cartoonito.com.uy/programacion';
        case 've':
            return 'https://www.cartoonito.com.ve/programacion';
        case 'ar':
            return 'https://www.cartoonito.com.ar/programacion';
        default:
            return 'https://www.cartoonitola.com/programacion';
    }
};

export default CartoonitoParentalWatch;
